module.exports = __webpack_public_path__ + "img/icon-24-ic-open-in-new-tab.0fbb198b.svg";